const mongoliaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111914)">
      <path
        d="M20.0004 40C22.4468 40 24.7903 39.56 26.9569 38.756L27.8265 20L26.957 1.24398C24.7903 0.440078 22.4468 0 20.0004 0C17.554 0 15.2105 0.440078 13.0439 1.24398L12.1743 20L13.0438 38.756C15.2105 39.56 17.554 40 20.0004 40Z"
        fill="#0052B4"
      />
      <path
        d="M0 20.0011C0 28.6004 5.4275 35.9313 13.0435 38.7571V1.24512C5.4275 4.07098 0 11.4018 0 20.0011Z"
        fill="#A2001D"
      />
      <path
        d="M26.9565 1.24512V38.7572C34.5726 35.9313 40.0001 28.6004 40.0001 20.0011C40.0001 11.4018 34.5726 4.07098 26.9565 1.24512Z"
        fill="#A2001D"
      />
      <path d="M9.56494 20H11.3041V26.9565H9.56494V20Z" fill="#FFDA44" />
      <path d="M2.6084 20H4.34754V26.9565H2.6084V20Z" fill="#FFDA44" />
      <path
        d="M6.95594 24.3484C7.91644 24.3484 8.69508 23.5698 8.69508 22.6093C8.69508 21.6488 7.91644 20.8701 6.95594 20.8701C5.99544 20.8701 5.2168 21.6488 5.2168 22.6093C5.2168 23.5698 5.99544 24.3484 6.95594 24.3484Z"
        fill="#FFDA44"
      />
      <path
        d="M6.95596 17.3904C7.43619 17.3904 7.82549 17.0011 7.82549 16.5209C7.82549 16.0407 7.43619 15.6514 6.95596 15.6514C6.47573 15.6514 6.08643 16.0407 6.08643 16.5209C6.08643 17.0011 6.47573 17.3904 6.95596 17.3904Z"
        fill="#FFDA44"
      />
      <path d="M5.21729 25.2168H8.69557V26.9559H5.21729V25.2168Z" fill="#FFDA44" />
      <path d="M5.21729 18.2598H8.69557V19.9989H5.21729V18.2598Z" fill="#FFDA44" />
      <path
        d="M6.95633 10.4346L7.57227 12.3299H9.56508L7.95297 13.5013L8.56844 15.3966L6.95633 14.2252L5.3443 15.3966L5.95977 13.5013L4.34766 12.3299H6.34047L6.95633 10.4346Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111914">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default mongoliaSvg;
